import React from 'react'
import { framework_tool, component_tool } from '@/tool'
import { Table } from 'antd'
const { WizButton } = component_tool
const { WizContainer } = framework_tool

class Coach extends WizContainer {

    componentName = 'Coach'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _onLook = (item) => {
        let { record, jumpPage } = this.props
        let { id, state } = item
        jumpPage && jumpPage('push', '/integrationCounseling/manager/coach', { ...record, processContentId: id, processContentState: state })
    }

    render() {
        let { contentList } = this.props.process
        let columns = [{
            title: '',
            name: 'state',
            dataIndex: 'state',
            align: 'center',
            width: 120,
            render: (v, r, i) => {
                let img = r.state === 0
                    ? constants.files.sys_counseling_content_in_progress
                    : constants.files.sys_counseling_content_completed
                return <img className='process-icon' src={img} />
            }
        }, {
            title: '执行内容',
            name: 'name',
            dataIndex: 'name'
        }, {
            title: '完成时间',
            name: 'completeTime',
            dataIndex: 'completeTime',
            align: 'center',
            width: 250
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 120,
            render: (v, r, i) => {
                let buttonProps = {
                    type: 'link',
                    onClick: () => this._onLook(r)
                }
                return <WizButton {...buttonProps}>{'查看'}</WizButton>
            }
        }]

        let tableProps = {
            columns,
            dataSource: contentList,
            pagination: false,
            bordered: true,
            rowKey: 'id'
        }

        return <Table {...tableProps} />
    }
}

export default Coach


